import React, { useState } from "react";
import { Modal } from "../modal";
import { API, endpoints } from "../../api";
import { toastType } from "../../utils/strings";
import { useAuth } from "../../context/Auth";
import { ResendOtp } from "./ResendOtp";

export const OtpModal = ({
    show,
    close,
    onVerified,
    mobileNumber,
    mobileCode,
    mobileCountryCode,
    btnText = "VERIFY",
}) => {
    const [otp, setOtp] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const { showToast, updateUser, user } = useAuth();

    const handleSubmit = (e) => {
        e.preventDefault();
        setError("");

        if (!otp || otp.length < 4) {
            setError("Please enter a valid OTP");
            return;
        }

        setLoading(true);

        const formData = new FormData();
        formData.append("otp", otp);
        formData.append("mobile_number", mobileNumber || "");
        formData.append("mobile_code", mobileCode || "");
        formData.append("mobile_country_code", mobileCountryCode || "");

        API.post({ route: endpoints.OTP_VERIFY, data: formData })
            .then((response) => {
                const responseData = response?.data;
                console.log("OTP Verify Response:", response, responseData);
                if (responseData?.status === false) {
                    const errorMessage = responseData?.message || "Invalid OTP. Please try again.";
                    setError(errorMessage);
                    showToast({
                        text: errorMessage,
                        type: toastType.ERROR,
                    });
                    return;
                }
                showToast({
                    text: "Mobile number verified successfully",
                    type: toastType.SUCCESS,
                });
                
                // Update user data with verified status
                if (responseData) {
                    updateUser({ ...user, user: { ...user?.user, mobile_verify: 1, ...responseData } });
                }
                
                if (onVerified) {
                    onVerified();
                }
                
                close();
                setOtp("");
            })
            .catch((error) => {
                const errorMessage = error?.response?.data?.message || "Invalid OTP. Please try again.";
                setError(errorMessage);
                showToast({
                    text: errorMessage,
                    type: toastType.ERROR,
                });
            })
            .finally(() => setLoading(false));
    };

    const handleOtpChange = (e) => {
        const value = e.target.value.replace(/\D/g, ""); // Only allow digits
        if (value.length <= 6) {
            setOtp(value);
            setError("");
        }
    };

    const handleSendOtp = () => {
        if (!mobileNumber || !mobileCode || !mobileCountryCode) {
            setError("Missing mobile number details. Please update your phone number.");
            return;
        }

        setLoading(true);

        const formData = new FormData();
        formData.append("mobile_number", mobileNumber);
        formData.append("mobile_code", mobileCode);
        formData.append("mobile_country_code", mobileCountryCode);

        API.post({ route: endpoints.SEND_OTP, data: formData })
            .then((response) => {
                const responseData = response?.data;
                if (responseData?.status === false) {
                    setError(responseData?.message || "Failed to send OTP. Please try again.");
                    return;
                }
                showToast({
                    text: "OTP sent to your mobile number.",
                    type: toastType.INFO,
                });
                if (responseData?.otp) {
                    showToast({
                        text: `OTP for testing: ${responseData.otp}`,
                        type: toastType.INFO,
                    });
                }
            })
            .catch((error) => {
                const message =
                    error?.response?.data?.message ||
                    "Failed to send OTP. Please try again.";
                setError(message);
            })
            .finally(() => setLoading(false));
    };

    return (
        <Modal show={show} close={close} style={{minHeight:350}}>
            <div className="notranslate">
                <form onSubmit={handleSubmit}>
                    {/* <h3 className="font-md fw-700">Verify Your Mobile Number</h3> */}
                    <p className="font-sm mt-3 mb-4 text-grey-900 mt-5">
                       An SMS with a one-time code has been sent to your mobile number.
                    </p>

                    {error && (
                        <div className="alert alert-danger font-xsss mb-3" role="alert">
                            {error}
                        </div>
                    )}

                    <div className="font-sm w-100 mb-4">
                        <div className="form-group">
                            
                            <input
                                type="text"
                                className="style2-input form-control text-grey-900 font-xsss fw-600"
                                placeholder="Enter 4 digit code*"
                                value={otp}
                                onChange={handleOtpChange}
                                maxLength={6}
                                pattern="[0-9]*"
                                inputMode="numeric"
                                required
                                autoFocus
                            />
                            <small className="text-grey-500 font-xssss mt-2">
                                * Code expires in 5 mins.
                            </small>
                        </div>
                    </div>

                    <div className="mt-4">
                        <div className="form-group pt-1">
                            <button
                                type="submit"
                                disabled={loading}
                                className="form-control text-center style2-input text-white fw-600 font-sm bg-primary-gradiant border-0 p-0"
                            >
                                {btnText}
                                {/* {loading ? "Verifying..." : "Verify"} */}
                            </button>
                        </div>

                        <div className="text-center mt-3">
                            <p className="font-xsss text-grey-600">
                                Didn't receive the code?{" "}
                                <ResendOtp
                                    onResend={handleSendOtp}
                                    initialSeconds={30}
                                    isVisible={show}
                                    resetKey={show}
                                    className="d-inline"
                                    label="Resend"
                                />
                            </p>
                        </div>
                    </div>
                </form>
            </div>
        </Modal>
    );
};
